import * as actionTypes from "./actionTypes";
import axios from "../../axios-common";
import { getLeadFilter } from "../../helpers";
import axiosLms from "../../axios-lmsv2";
import axiosRequest from "../../axios-request/request.methods";
import supportLead from "../../components/LeadCards/supportLeads";
import { stoageGetter ,checkPartnerUser} from "../../helpers";
import { subSourceData } from "./subSource";

// console.warn("State-------------->", actionTypes.FETCH_LEAD_TYPE);
// Fetch leads data
let leadtype = "";
export const fetchLeadType = (payload) => {
  //console.log(payload);
  leadtype = payload;
  // console.log("SELFTEST-++++++++++++++++>",payload)
  return {
    type: actionTypes.FETCH_LEAD_TYPE,
    leadType: payload,
  };
};
export const fetchAllLeadsStart = () => {
  return {
    type: actionTypes.FETCH_ALL_LEADS_START,
  };
};

export const fetchAllLeadsSuccess = (allLeads, count) => {
  // //console.log("PAYLOAD DATA_------->",allLeads);
  return {
    type: actionTypes.FETCH_ALL_LEADS_SUCCESS,
    allLeads: allLeads,
    count: count,
    // subSourceArr: subSourceArr,
  };
};

export const fetchAllLeadsFail = (error) => {
  return {
    type: actionTypes.FETCH_ALL_LEADS_FAIL,
    error: error,
  };
};

export const addAllTeamCount = (count) => {
  return {
    type: actionTypes.FETCH_ALL_TEAM_COUNT,
    payload: count,
  };
};

export const addAllTeamCountSe = (countT) => {
  return {
    type: actionTypes.FETCH_ALL_TEAM_COUNTT,
    payload1: countT,
  };
};

export const fetchMultiLiId = (payload) => {
  //console.log("payload multiLi-------------------- >", payload);
  leadtype = payload;
  return {
    type: actionTypes.FETCH_MULTI_SELECTED_ID,
    multiLiId: payload,
  };
};

export const fetchAllLeads = (id, leads, pageNo, LeadID) => {
  // //console.log("SELFTEST-++++++++++++++++>",leadtype)
  let skipVal;
  // //console.log("LEAD--------->", leads,LeadID,id,pageNo);
  pageNo === 1 ? (skipVal = 0) : (skipVal = (pageNo - 1) * 15);
  let result = "";

  return async (dispatch) => {
    // Check if id is valid before making API calls
    if (!id) {
      console.warn("fetchAllLeads: Invalid id provided, skipping API call");
      dispatch(fetchAllLeadsFail());
      return;
    }

    // if(leadtype == "Self Sourced"){
    //     // result = await axiosRequest.get(`user/getLead/${id}?skip=${skipVal}&searchType=leadSource&searchtxt=Self Sourced&leadfilter=all`, { secure: true });
    // }else
    if(checkPartnerUser()){
      if(leadtype === 'LSQ'){
        leadtype = 'LSQ'
      }else{
        leadtype = 'all'
      }
    }else{
      leadtype = 'LSQ'
    }
    console.log("Lead Type Check ====>>>",leadtype)
    if (leadtype == "LSQ") {
      result = await axiosRequest.get(`user/getLead/${id}?leadfilter=${leads}&source=LSQ&skip=${skipVal}`, { secure: true });
    } else if (leadtype == "Self Sourced") {
      result = await axiosRequest.get(`user/getLead/${id}?leadfilter=${leads}&source=Self Sourced&skip=${skipVal}`, { secure: true });
    } else {
      result = await axiosRequest.get(`user/getLead/${id}?leadfilter=${leads}&skip=${skipVal}`, { secure: true });
      // result = await axiosRequest.get(`user/getLead/${id}?leadfilter=${leads}&lead_Id=${LeadID}`, { secure: true });
      // result = await axiosRequest.get(`user/getLead/${id}?leadfilter=${leads}&source=Self Sourced`, { secure: true })
    }
    dispatch(fetchAllLeadsStart());

    if (result.length > 0) {
      // //console.log("RESULT_______________>", result[0]);
      let subsourceArr;
      if (result[2] && Array.isArray(result[2])) {
        subsourceArr = result[2].map((item) => {
          return { label: item, value: item };
        });
      } else {
        return [];
      }
      // //console.log("resltt------------>",subsourceArr)
      let checksubSrc = subsourceArr ? subsourceArr : [];
      dispatch(subSourceData(checksubSrc));
      dispatch(
        fetchAllLeadsSuccess(
          supportLead.readSortDataFromAPI(leads, result === "No leads found" ? [] : result[0], this),
          result[1][0].count
          //   checksubSrc
        )
      );
      //console.log(result[1][0].count);
    } else {
      dispatch(fetchAllLeadsFail());
    }
  };
};

export const fetchDataAfterFilter = (id, skip, searchtxt, leadStatus, sorByFlter, sort_status, leadfilter, leadDisposition, leadType, searchType, sourceBy, source, subSource) => {
  // //console.log(
  //   "LEAD FILTER FROM ACTION------->",
  //   id,
  //   skip,
  //   searchtxt,
  //   leadStatus,
  //   sorByFlter,
  //   sort_status,
  //   leadfilter,
  //   leadDisposition,
  //   leadType,
  //   searchType,
  //   sourceBy,
  //   source,
  //   subSource
  // );
  let result = "";
  return async (dispatch) => {
    // Check if id is valid before making API calls
    if (!id) {
      console.warn("fetchDataAfterFilter: Invalid id provided, skipping API call");
      dispatch(fetchAllLeadsFail());
      return;
    }

    dispatch(fetchAllLeadsStart());
    // &searchType=fname
    let url = `user/getLead/${id}?skip=${skip}`;

    if (searchType.trim().length) url += `&searchType=${searchType}`;
    if (searchtxt.trim().length) {
      url += `&searchtxt=${searchtxt}`;
    }
    if (leadStatus.trim().length) {
      url += `&leadStatus=${leadStatus}`;
    }
    if (sorByFlter.trim().length) {
      url += `&sorByFlter=${sorByFlter}`;
    }
    if (sort_status.trim().length) {
      url += `&sort_status=${sort_status}`;
    }
    if (leadfilter.trim().length) {
      url += `&leadfilter=${leadfilter}`;
    }
    if (leadDisposition.trim().length) {
      url += `&leadDisposition=${leadDisposition}`;
    }
    if (leadType.trim().length) {
      url += `&leadType=${leadType}`;
    }
    if (sourceBy?.trim().length) {
      url += `&sourceBy=${sourceBy}`;
    }
    if (source == "LSQ") {
      url += `&source=${source}`;
    }
    if (subSource?.trim().length) {
      url += `&subSource=${subSource}`;
    }
    if (source == "Self Sourced") {
      url += `&source=${source}`;
    }

    // //console.log("URL---------->", url);
    // if(leadtype == "Self Sourced"){
    //     result = await axiosRequest.get(`user/getLead/${id}?skip=${skip}&searchType=leadSource&searchtxt=Self Sourced&leadfilter=all`)
    // }
    // else
    if (leadtype == "LSQ") {
      result = await axiosRequest.get(url);
    } else if (leadtype == "Self Sourced") {
      result = await axiosRequest.get(url);
    } else {
      result = await axiosRequest.get(url);
    }
    console.warn("_______Filter", result);
    if (result.length > 0) {
      // //console.log(
      //   "Result after filter=+++++++++++++++++++++++++++++++>",
      //   result
      // );
      dispatch(fetchAllLeadsSuccess(supportLead.readSortDataFromAPI(leadfilter, result[0], this), result[1][0].count));
      // dispatch(fetchAllLeadsSuccess(result[0], result[1][0].count));
    } else {
      dispatch(fetchAllLeadsFail());
    }
  };
};

// Fetch Designation

export const fetchDesignationStart = () => {
  return {
    type: actionTypes.FETCH_DESIGNATION_START,
  };
};

export const fetchDesignationSuccess = (designations) => {
  return {
    type: actionTypes.FETCH_DESIGNATION_SUCCESS,
    designations: designations,
  };
};

export const fetchDesignationFail = (error) => {
  return {
    type: actionTypes.FETCH_DESIGNATION_FAIL,
    error: error,
  };
};

export const fetchDesignation = (channelCode) => {
  return (dispatch) => {
    dispatch(fetchDesignationStart());
    return axios
      .get(`admin/getDesignationMaster?userId=5b3b4cc28fa96d39870443e3&channelCode=5dbfdfa8e51cd5522249ba70`)
      .then((res) => {
        if (res.data.errCode === -1) {
          return dispatch(fetchDesignationSuccess(res.data.errMsg[0]));
        }
      })
      .catch((error) => {
        return dispatch(fetchDesignationFail(error.response.data.errors));
      });
  };
};

// Fetch Team Member

export const fetchTeamMemberStart = () => {
  return {
    type: actionTypes.FETCH_TEAM_MEMBER_START,
  };
};

export const fetchTeamMemberSuccess = (teamMember) => {
  return {
    type: actionTypes.FETCH_TEAM_MEMBER_SUCCESS,
    teamMember: teamMember,
  };
};

export const fetchTeamMemberFail = (error) => {
  return {
    type: actionTypes.FETCH_TEAM_MEMBER_FAIL,
    error: error,
  };
};

export const fetchTeamMember = (id) => {
  return (dispatch) => {
    dispatch(fetchTeamMemberStart());
    return axiosLms
      .get(`user_tree?userId=6153f1ec4735ef7f942926e3`)
      .then((res) => {
        //console.log(res.data.errMsg);
        if (res.data.errCode === -1) {
          return dispatch(fetchTeamMemberSuccess());
        } else {
          throw res;
        }
      })
      .catch((error) => {
        //console.log(error);
        return dispatch(fetchTeamMemberFail(error));
      });
  };
};

//----- ACTION FOR CHANGE TAB
export const updateTabOfDashboard = (globalTab) => {
  return {
    type: actionTypes.UPDATE_TAB_POSSITION,
    globalTab: globalTab,
  };
};

export const proposalTeamSelect = (proposal) => {
  return {
    type: actionTypes.UPDATE_PROPOSAL_TEAM,
    proposalTeamUser: proposal,
  };
};

export const proposalTeamData = (proposal) => {
  return {
    type: actionTypes.PROPOSAL_TEAM_DATA,
    proposalTeamData: proposal,
  };
};

export const showProposalTable = (data) => {
  return {
    type: actionTypes.SHOW_PROPOSAL_TABLE,
    showProposalTable: data,
  };
};

export const selectedFilterBy = (data) => {
  return {
    type: actionTypes.SELECTED_FILTER_BY,
    selectedFilterBy: data,
  };
};

// Action for Allocate satus

export const updateAllocateOfOpportunities = (allocate) => {
  return {
    type: actionTypes.UPDATE_ALLCATION_TAB_POSSITION,
    allocateTab: allocate,
  };
};

// Action to store all checked leads

export const updateCheckAllocatedLead = (checkedLead) => {
  return {
    type: actionTypes.UPDATE_ALLCATED_CHECKED_LEADS,
    checkedLead: checkedLead,
  };
};

export const clearLeadsDetail = () => {
  return {
    type: actionTypes.RESET_LEAD,
  };
};
